
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getBudgetSalaryEmployeeDetailDtoFormGroup() {
return new FormGroup({
    userId: new FormControl<number | undefined>(undefined, [Validators.required]),
    firstName: new FormControl<string | undefined>(undefined),
    lastName: new FormControl<string | undefined>(undefined),
    employmentType: new FormControl<string | undefined>(undefined),
    workload: new FormControl<number | undefined>(undefined),
    salaryGross: new FormControl<number | undefined>(undefined),
    pricePerHour: new FormControl<number | undefined>(undefined),
    monthlySalaryBase: new FormControl<number | undefined>(undefined, [Validators.required]),
    monthlySalaryWithMarkup: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      